import { Injectable } from '@angular/core';
import {
  LogActions,
  Logs,
  LogsExtended,
  Logs_Insert_Input,
  Payload,
} from '@etoh/database/core';

import { take } from 'rxjs';
import { DatasService } from '../../datas.service';

@Injectable({
  providedIn: 'root',
})
export class LogsService {
  constructor(private dataService: DatasService) {}

  public add(action: LogActions, payload: Payload) {
    if (payload.cellsLength < 50) {
      return;
    }

    const logToInsert: Logs_Insert_Input = {
      action,
      url: window.location.href,
      payload,
    };

    this.dataService
      .insertDatas<Logs>('logs', logToInsert as any)
      .pipe(take(1))
      .subscribe((l) => {
        console.log('log added', l);
      });
  }
}
